import { ThresholdPrice } from '@/utils/commission/constants';

export const ListSideCommissionRates = [
  {
    value: 3.78,
    thresholdPrice: ThresholdPrice.Min,
  },
  {
    value: 1.35,
    thresholdPrice: ThresholdPrice.Max,
  },
];
